/* Valore di etichetta selezionato
null | {"value": "benchmark" | "anomaly" | "unknown" | "none", ...}
*/
import { createContext } from "react";
const SelectedLabelContext = createContext({
    selectedLabel: null,
    setSelectedLabel: (label) => {}
  });
export default SelectedLabelContext;